import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

/**
 * Actions for key learning area
 */

/**
 * Action for fetch all key learning areas
 * @param {*} payload
 */
export function fetchKeyLearningAreas(payload) {
  return { type: actionTypes.FETCH_KEY_LEARNING_AREAS, payload };
}
export function fetchKeyLearningAreasSuccess(payload) {
  const byId = keyBy(payload, (kla) => kla.klaUid);
  return {
    type: actionTypes.FETCH_KEY_LEARNING_AREAS_SUCCESS,
    payload: { byId },
  };
}
export function fetchKeyLearningArea(payload) {
  return { type: actionTypes.FETCH_KEY_LEARNING_AREA, payload };
}
export function fetchKeyLearningAreaSuccess(payload) {
  const byId = { [payload.klaUid]: payload };
  return {
    type: actionTypes.FETCH_KEY_LEARNING_AREA_SUCCESS,
    payload: { byId },
  };
}
